module.exports = __webpack_public_path__ + "img/panorama.3a2bbd21.png";